<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
        v-if="false"
          is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
          btn-background="bg-color-verde-plano"
          :dark-mode="true"
        />
      </div>
    </div>
  </div>
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="page-header min-vh-75">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-6 d-flex flex-column">
              <div class="mt-8 card card-plain">
                <img :src="logo" class="img-login" alt="main_logo" />
                <div class="pb-0 card-header text-start">
                  <h3 class="font-weight-bolder ">
                    Establecer Contraseña
                  </h3>
                  <p class="mb-0">Estás a tan solo un paso de poder acceder a Narvik! 🎉</p>
                </div>
                <div class="card-body">
                  <form autocomplete="off" @submit.stop.prevent="send()" rol="form" class="text-start">
                   
                    <label>Contraseña</label>
                    <input
                      v-model="form.repeat_password"
                      id="password"
                      type="password"
                      placeholder="Contraseña"
                      name="password"
                      class="form-control"
                      autocomplete="off"
                      required
                    />
                    <label>Repetir Contraseña</label>
                    <input
                      v-model="form.password"
                      id="password"
                      type="password"
                      placeholder="Contraseña"
                      name="password"
                      autocomplete="off"
                      class="form-control"

                      required
                    />
                    <div v-if="this.error" class="alert alert-danger mt-3">
                      Parece que hay algun Error
                    </div>

                    <div v-if="this.success" class="alert alert-success mt-3">
                      Enhorabuena!, su contraseña se ha cambiado correctamente. <hr> Accede al 
                      <router-link
                      :to="{ name: 'Sign In' }"
                      class="font-weight-bold"
                      >Login</router-link> para continuar
                    </div>
                    <!-- <soft-switch id="rememberMe" name="rememberMe" checked>
                      Remember me
                    </soft-switch> -->
                    <div class="text-center">
                      <soft-button
                        class="my-4 mb-2"
                        variant="gradient"
                        color="success"
                        full-width
                        v-if="!loading && !success"
                        >
                        <div v-if="!loading">
                          Enviar
                        </div>
                        <div v-else class="spinner-border" rol="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </soft-button>
                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    ¿Ya recuerdas tu contraseña?
                    <router-link
                      :to="{ name: 'Sign In' }"
                      class="font-weight-bold"
                      >Iniciar Sesión</router-link>
                    
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div
                class="top-0 oblique position-absolute h-100 d-md-block d-none me-n8 coverSignIn"
              >
                <div
                  class="bg-cover oblique-image position-absolute fixed-top ms-auto h-100 z-index-0 ms-n6 "
                  :style="{
                    backgroundImage:
                      'url(' +
                      require('@/assets/img/curved-images/curved14.jpg') +
                      ')',
                  }"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <app-footer />
</template>

<script>
import logo from "@/assets/img/logo-small.png";

import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
// import SoftInput from "@/components/SoftInput.vue";
// import SoftSwitch from "@/components/SoftSwitch.vue";
import SoftButton from "@/components/SoftButton.vue";
const body = document.getElementsByTagName("body")[0];
import { mapMutations } from "vuex";
import axios  from 'axios';
import cookie from 'cookiejs';
import { RouterLink } from "vue-router";

export default {
  data() {
    return {
      logo,
      form: {
        email: null,
        password: null
      },
      loading: false,
      error: false,
      success: false
    }
  },
  name: "SignIn",
  components: {
    Navbar,
    AppFooter,
    // SoftInput,
    // SoftSwitch,
    SoftButton,
    RouterLink
},
  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    send() {
      if(this.form.password !== this.form.repeat_password){
        alert("Parece que las contraseñas no coinciden")
        return ;
      }
      this.loading = true;
      this.error = false;
      axios
      .post(this.$store.state.baseUrl+'/api/user/forget/stablish',{
        token: this.$route.query.token, 
        password: this.form.password
      })
      .then((response) => {
         if(response.data.rc == 1) {
          this.success = true;

         }
         else {
          this.success = true;         
        }
      })
      .catch(() => {
          this.error = true;
          
        })
        // finally
        .finally(() => {
          this.loading = false;
        });


    },
    loginSuccess(data) {
      // add data user
      this.$store.state.auth = data.user;
      // add token to cookie
      cookie.set("authToken",data.token,{expires: 365});
      // push the router to home
      // this.$router.push({ name: "/" }); 
      window.location.href = '/';
    }
  },
};
</script>

<style>

</style>
